import { Link } from "react-router-dom";
import affiliateScreenshot from "@/assets/affiliate-tools-screenshot.png";

export default function AffiliateToolsSection() {
  return (
    <section className="py-20 px-5 sm:px-8 bg-gradient-to-br from-slate-950 via-orange-950 to-slate-900 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left — text */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-orange-500/20 border border-orange-400/30 text-orange-300 text-xs font-semibold mb-6">
              <i className="ri-links-fill"></i>
              Affiliate Marketing Suite
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-5 leading-tight">
              Turn Any Affiliate Link Into a
              <span className="block bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">
                Full Marketing Campaign
              </span>
            </h2>
            <p className="text-slate-300 text-base leading-relaxed mb-6">
              Paste your affiliate URL and let our AI instantly generate platform-specific promotional content for Facebook, Instagram, Twitter/X, TikTok, LinkedIn, and YouTube Shorts — with your tracking link auto-embedded in every post.
            </p>
            <ul className="space-y-3 mb-8">
              {[
                { icon: "ri-links-fill", text: "Paste any affiliate URL — Amazon, ClickBank, JVZoo, and more" },
                { icon: "ri-robot-2-fill", text: "AI generates unique promotional copy for each platform" },
                { icon: "ri-fingerprint-fill", text: "Your affiliate ID auto-embedded in all content" },
                { icon: "ri-share-forward-2-fill", text: "One click publishes to 6+ platforms simultaneously" },
                { icon: "ri-bar-chart-box-fill", text: "Track clicks, conversions, and earnings in your dashboard" },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3 text-sm text-slate-300">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-orange-500/20 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-orange-400 text-sm`}></i>
                  </div>
                  {item.text}
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/affiliate-tools"
                className="px-6 py-3 rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 text-white font-semibold text-sm hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
              >
                Try Affiliate Tools
              </Link>
              <Link
                to="/get-started"
                className="px-6 py-3 rounded-xl border border-white/20 text-white font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                View Plans
              </Link>
            </div>
          </div>

          {/* Right — screenshot */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-amber-500/20 rounded-3xl blur-3xl scale-110"></div>
            <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-white/5 p-4">
              <img
                src={affiliateScreenshot}
                alt="Affiliate Marketing Suite — URL to marketing campaign generator"
                className="w-full h-auto object-contain rounded-xl"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
